// extracted by mini-css-extract-plugin
export default {"root":"ScrollToButtonMessageListButton_root__+p7LP"};